import {TriangleAlert} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";
import {QuotaWarningLevel} from "../../hooks/useQuotaWarning";
import {NotificationBanner} from "./banners/NotificationBanner";

interface QuotaBannerProps {
    level: Exclude<QuotaWarningLevel, "none">;
    onClose: () => void;
}

export function QuotaBanner({level, onClose}: QuotaBannerProps) {
    const {t} = useTranslationWithKeys();
    const navigate = useNavigate();

    return (
        <NotificationBanner
            variant={level === "exceeded" ? "destructive" : "warning"}
            icon={<TriangleAlert/>}
            message={t(`licenses.quotaBanner.${level}`)}
            action={{
                label: t('licenses.quotaBanner.viewLicenses'),
                onClick: () => navigate("/licenses"),
            }}
            onClose={onClose}
        />
    );
}
